module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_gross_and_micro-4c710654615479532a9e57c15707b350.png";